import * as React from "react";
import history from "../history";
import IconButton from '@material-ui/core/IconButton';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import SearchIcon from '@material-ui/icons/Search';
import MenuIcon from '@material-ui/icons/Menu';

export class Header extends React.Component<any, any> {

    onClickAction = () => {
        if (!this.props.samePageAction) {
            history.push(this.props.url);
        } else {
            this.props.samePageAction();
        }
    }

    render() {
        return (
            <header className="header">
                {this.props.isBackButtonVisible ?
                    <button type="button" className="back-nav-btn" onClick={this.onClickAction}>
                        <i className="fas fa-arrow-left"></i>
                    </button> : null}

                {this.props.isSettingsButtonVisible ?
                    <IconButton
                        aria-label="open drawer"
                        onClick={this.props.handleDrawerOpen}
                        className="settings-btn"
                    >
                        <MenuIcon />
                    </IconButton> : null}

                <h1 className="logo_heading">
                    {this.props.title}
                </h1>

                {this.props.isSignOutButtonVisible ?
                    <button type="button" className="sign-out-btn" onClick={() => { this.props.signOutAction() }}>
                        <PowerSettingsNewIcon />
                    </button> : null}

                {this.props.isSearchButtonVisible ?
                    <button type="button" className="search-btn" onClick={() => { this.props.searchAction() }}>
                        <SearchIcon />
                    </button> : null}
            </header>
        )
    }
}